var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-traveler-item" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "order-traveler-item__text" }, [
      _c("span", { staticClass: "order-traveler-item__title" }, [
        _vm._v(_vm._s(_vm.type) + " " + _vm._s(_vm.number))
      ]),
      _vm._v(" "),
      _vm.traveller
        ? _c("span", {
            staticClass: "order-traveler-item__name",
            domProps: { textContent: _vm._s(_vm.name) }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-traveler-item__icon" }, [
      _c("img", {
        staticClass: "included-item__icon",
        attrs: { src: require("./../../img/icons/icon-person.svg") }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1752a590", { render: render, staticRenderFns: staticRenderFns })
  }
}